// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1956":"cb9706ad","2480":"cb9706ad","3850":"488efc22","8815":"eb76a8ac"}[chunkId] + ".chunk.css";
};